import { toggleReset } from "../../reduxSlices/resetToggleSlice";
import "../resetSuccess/resetSuccess.css";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

function ResetSuccess({ color }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  //timeout addeed for closing after 1 sec
  setTimeout(() => {
    dispatch(toggleReset(false));
  }, 1000);

  return (
    <div
      className="absolute z-99 w-[90%] rounded-[0.375rem] top-[11vh] resetContainer"
      style={{ background: color }}
    >
      <div className="w-[2.25rem] h-[2.25rem] flex items-center justify-center aspect-square">
        <div
          style={{ backgroundImage: `url(${"/innerWidget/resetSuccess.svg"})` }}
          className="w-[100%] h-[100%] bg-no-repeat bg-center bg-contain"
          alt="reset complete"
        />
      </div>
      <div className="text-primary-background text-secondary font-[600] leading-[1.375rem] ml-[1.25rem] accessBilityText">
        {t("Accessibility settings have been reset successfully")}
      </div>
      <div
        className="md:ml-[3.75rem] w-[2rem] h-[2rem] flex items-center justify-center aspect-square cursor-pointer"
        onClick={() => dispatch(toggleReset(false))}
      >
        <div
          style={{ backgroundImage: `url(${"/innerWidget/closeReset.svg"})` }}
          className="w-[100%] h-[100%] bg-no-repeat bg-center bg-contain"
          alt="close reset"
        />
      </div>
    </div>
  );
}
export default ResetSuccess;

